import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Badge, Table, Form, Button, InputGroup, Dropdown, Image } from 'react-bootstrap';
import {
    FaBell,
    FaCog,
    FaCalendarAlt,
    FaClipboardList,
    FaChartBar,
    FaBullhorn,
    FaQuoteRight,
    FaMapMarkerAlt,
    FaPhone,
    FaCheckCircle,
    FaExclamationCircle,
    FaTimesCircle,
    FaUser,
    FaPaperPlane,
    FaTrashAlt,
    FaEye,
    FaFilter,
    FaSort,
    FaChevronDown,
    FaSearch,
    FaBars,
    FaTimes,
    FaDownload,
    FaPrint
} from 'react-icons/fa';
import './NotificationPage.css';
import GlobalMiniSidebar from './GlobalMiniSidebar';

const NotificationManagementPage = () => {
    const [appointmentDate] = useState('Mar 9, 2025');
    const [showSidebar, setShowSidebar] = useState(false);
    const [activeTimeframe, setActiveTimeframe] = useState('Daily');
    const sidebarRef = useRef(null);

    // Sample data for notifications
    const notificationsList = [
        {
            id: 1,
            date: 'Mar 9 2025',
            time: '12:00',
            content: "Hey, it's time for your monthly check-up!",
            target: 'Everyone',
            type: 'SMS',
            status: 'Sent'
        },
        {
            id: 2,
            date: 'Mar 9 2025',
            time: '14:30',
            content: "Hi, we want to remind you about your appointment tomorrow",
            target: 'Not Confirmed',
            type: 'Email',
            status: 'Scheduled'
        },
        {
            id: 3,
            date: 'Mar 9 2025',
            time: '12:00',
            content: "Dear Patient, it looks like you've missed your appointment",
            target: 'Cancelled',
            type: 'SMS + Email',
            status: 'Sent'
        }
    ];

    // Toggle sidebar for mobile view
    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    // Close sidebar when clicking outside on mobile
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (window.innerWidth < 768 &&
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                !event.target.closest('.menu-toggle')) {
                setShowSidebar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Check window size and adjust sidebar visibility
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setShowSidebar(false);
            } else {
                setShowSidebar(true);
            }
        };

        // Initial check
        handleResize();

        // Listen for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Container fluid className="chat-container p-0">
            <div className="d-flex chat-wrapper">
                {/* Mini Sidebar - Always visible */}
                {/* <div className="mini-sidebar">
                    <div className="mini-sidebar-content">
                        <div className="app-logo">
                            <div className="logo-icon">JI</div>
                        </div>
                        <div className="nav-links">
                            <div className="nav-item active">
                                <FaBell />
                            </div>
                            <div className="nav-item">
                                <FaCalendarAlt />
                            </div>
                            <div className="nav-item">
                                <FaClipboardList />
                            </div>
                            <div className="nav-item">
                                <FaChartBar />
                            </div>
                            <div className="nav-item">
                                <FaBullhorn />
                            </div>
                            <div className="nav-item">
                                <FaCog />
                            </div>
                        </div>
                        <div className="nav-bottom">
                            <div className="nav-item theme-toggle">
                                <FaCog />
                            </div>
                        </div>
                    </div>
                </div> */}
                <GlobalMiniSidebar />

                {/* Main Content Area */}
                <div className="chat-main-container">
                    {/* Mobile Sidebar Overlay */}
                    {showSidebar && window.innerWidth < 768 && (
                        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
                    )}

                    <div className="d-flex h-100 position-relative">
                        {/* Left Sidebar - Toggleable on mobile */}
                        <div
                            ref={sidebarRef}
                            className={`chat-sidebar ${showSidebar ? 'show-sidebar' : 'hide-sidebar'}`}
                        >
                            {/* Mobile Close Button */}
                            <div className="d-md-none sidebar-close">
                                <button className="close-btn" onClick={toggleSidebar}>
                                    <FaTimes />
                                </button>
                            </div>

                            {/* Sidebar Header */}
                            <div className="sidebar-header d-flex align-items-center p-3">
                                <div className="user-avatar me-3">
                                    <div className="notification-icon">
                                        <FaBell size={24} />
                                        <Badge bg="danger" className="notification-badge">10</Badge>
                                    </div>
                                </div>
                                <div className="header-text">
                                    <h5 className="mb-0">Notifications</h5>
                                </div>
                            </div>

                            {/* Time Range Select */}
                            <div className="p-3 border-bottom">
                                <Form.Group>
                                    <Form.Label>Time Range</Form.Label>
                                    <Form.Select aria-label="Select time range">
                                        <option>Last 30 days</option>
                                        <option>Last 7 days</option>
                                        <option>This month</option>
                                        <option>Last month</option>
                                        <option>Custom range</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Location selector */}
                            {/* <div className="p-3 border-bottom">
                                <Form.Group>
                                    <Form.Label>Location</Form.Label>
                                    <Form.Select className="custom-select">
                                        <option>Entirix, NY</option>
                                        <option>Downtown, NY</option>
                                        <option>Westside, NY</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                            
                            <div className="p-3 border-bottom">
                                <Form.Group>
                                    <Form.Label>Location Number</Form.Label>
                                    <InputGroup>
                                        <Form.Control value="+91-9812345678" readOnly />
                                        <Button variant="outline-primary">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 4V16C8 16.5304 8.21071 17.0391 8.58579 17.4142C8.96086 17.7893 9.46957 18 10 18H18C18.5304 18 19.0391 17.7893 19.4142 17.4142C19.7893 17.0391 20 16.5304 20 16V7.242C20 6.97556 19.9467 6.71181 19.8433 6.46624C19.7399 6.22068 19.5885 5.99824 19.398 5.812L16.188 2.602C16.0018 2.41147 15.7793 2.26014 15.5338 2.15672C15.2882 2.05329 15.0244 2.00001 14.758 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V4Z" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M16 18V20C16 20.5304 15.7893 21.0391 15.4142 21.4142C15.0391 21.7893 14.5304 22 14 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V8C4 7.46957 4.21071 6.96086 4.58579 6.58579C4.96086 6.21071 5.46957 6 6 6H8" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                            </div> */}

                            {/* Navigation links */}
                            <div className="analytics-nav p-2">
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2 active">
                                    <FaBell className="me-3" />
                                    <span>Notifications</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaClipboardList className="me-3" />
                                    <span>Reminders</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaCalendarAlt className="me-3" />
                                    <span>Appointments</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaCalendarAlt className="me-3" />
                                    <span>Calendar</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaChartBar className="me-3" />
                                    <span>Metrics</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaBullhorn className="me-3" />
                                    <span>Campaigns</span>
                                </div>
                                <div className="nav-item d-flex align-items-center p-2 rounded mb-2">
                                    <FaQuoteRight className="me-3" />
                                    <span>Quotes</span>
                                </div>
                            </div>

                            {/* Export Options */}
                            <div className="export-options p-3 mt-auto border-top">
                                <h6 className="text-muted mb-3">Export</h6>
                                <Button variant="outline-primary" className="me-2">
                                    <FaPrint className="me-2" />
                                    Print
                                </Button>
                                <Button variant="outline-primary">
                                    <FaDownload className="me-2" />
                                    Export PDF
                                </Button>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="chat-content-area">
                            {/* Content Header */}
                            <div className="chat-profile-header">
                                <Row className="align-items-center m-0">
                                    <Col xs="auto" className="d-md-none menu-toggle">
                                        <button
                                            className="action-icon-btn me-2"
                                            onClick={toggleSidebar}
                                            aria-label="Toggle sidebar"
                                        >
                                            <FaBars />
                                        </button>
                                    </Col>
                                    <Col className="d-flex align-items-center">
                                        <div className="profile-info">
                                            <h4 className="mb-0 profile-name">Notification Management</h4>
                                            <div className="online-status">
                                                <span className="text-muted">Overview for</span> {appointmentDate}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs="auto" className="profile-actions">
                                        <div className="action-icons">
                                            <Dropdown>
                                                <Dropdown.Toggle as="button" className="action-icon-btn">
                                                    {activeTimeframe}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item onClick={() => setActiveTimeframe('Daily')}>Daily</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setActiveTimeframe('Weekly')}>Weekly</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setActiveTimeframe('Monthly')}>Monthly</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setActiveTimeframe('Quarterly')}>Quarterly</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <button className="action-icon-btn">
                                                <FaSearch />
                                            </button>
                                            <button className="action-icon-btn">
                                                <FaFilter />
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Content Scrollable Area */}
                            <div className="summary-content-wrapper">
                                <div className="summary-content p-3">
                                    {/* Appointments Overview */}
                                    <div className="appointments-overview mb-4">
                                        <h2 className="section-title">Today's Appointments</h2>
                                        <p className="text-muted">{appointmentDate}</p>

                                        <Row className="mt-3">
                                            <Col md={3} sm={6} className="mb-3 mb-md-0">
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Body className="d-flex align-items-center">
                                                        <div className="icon-box bg-light rounded p-3">
                                                            <FaCheckCircle className="text-success" size={24} />
                                                        </div>
                                                        <div className="ms-3">
                                                            <h3 className="mb-0">25</h3>
                                                            <p className="text-muted mb-0">Confirmed</p>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-3 mb-md-0">
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Body className="d-flex align-items-center">
                                                        <div className="icon-box bg-light rounded p-3">
                                                            <FaExclamationCircle className="text-warning" size={24} />
                                                        </div>
                                                        <div className="ms-3">
                                                            <h3 className="mb-0">10</h3>
                                                            <p className="text-muted mb-0">Not Confirmed</p>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-3 mb-md-0">
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Body className="d-flex align-items-center">
                                                        <div className="icon-box bg-light rounded p-3">
                                                            <FaTimesCircle className="text-danger" size={24} />
                                                        </div>
                                                        <div className="ms-3">
                                                            <h3 className="mb-0">15</h3>
                                                            <p className="text-muted mb-0">Cancelled</p>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-3 mb-md-0">
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Body className="d-flex align-items-center">
                                                        <div className="icon-box bg-light rounded p-3">
                                                            <FaUser className="text-primary" size={24} />
                                                        </div>
                                                        <div className="ms-3">
                                                            <h3 className="mb-0">50</h3>
                                                            <p className="text-muted mb-0">Appointments</p>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Notifications Management */}
                                    <Card className="mb-4 shadow-sm">
                                        <Card.Header className="bg-white">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h5 className="mb-0">Manage Custom Notifications</h5>
                                                <Button variant="outline-secondary" size="sm">
                                                    <FaDownload className="me-1" /> Export
                                                </Button>
                                            </div>
                                        </Card.Header>
                                        <Card.Body className="p-0">
                                            <div className="table-responsive">
                                                <Table className="mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="sortable">
                                                                # <FaSort className="ms-1" />
                                                            </th>
                                                            <th className="sortable">
                                                                Date & Time <FaSort className="ms-1" />
                                                            </th>
                                                            <th className="sortable">
                                                                Content <FaSort className="ms-1" />
                                                            </th>
                                                            <th className="sortable">
                                                                Target <FaSort className="ms-1" />
                                                            </th>
                                                            <th className="sortable">
                                                                Type <FaSort className="ms-1" />
                                                            </th>
                                                            <th className="sortable">
                                                                Status <FaSort className="ms-1" />
                                                            </th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {notificationsList.map(notification => (
                                                            <tr key={notification.id}>
                                                                <td>{notification.id}</td>
                                                                <td>{notification.date} • {notification.time}</td>
                                                                <td className="content-cell">{notification.content}</td>
                                                                <td>
                                                                    <Badge
                                                                        bg={
                                                                            notification.target === 'Everyone' ? 'primary' :
                                                                                notification.target === 'Not Confirmed' ? 'warning' :
                                                                                    'danger'
                                                                        }
                                                                        className="target-badge"
                                                                    >
                                                                        {notification.target}
                                                                    </Badge>
                                                                </td>
                                                                <td>{notification.type}</td>
                                                                <td>
                                                                    <Badge
                                                                        bg={notification.status === 'Sent' ? 'success' : 'info'}
                                                                        className="status-badge"
                                                                    >
                                                                        {notification.status}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    <div className="action-buttons">
                                                                        <Button variant="link" size="sm" className="text-danger p-1">
                                                                            <FaTrashAlt />
                                                                        </Button>
                                                                        <Button variant="link" size="sm" className="text-primary p-1">
                                                                            <FaEye />
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Card.Body>
                                        <Card.Footer className="bg-white text-center">
                                            {/* <Button variant="link" className="text-decoration-none">
                                                View All Notifications
                                            </Button> */}

                                            <Link to={'/notification-all'} className="text-decoration-none" variant="link">
                                                View All Notifications
                                            </Link>

                                        </Card.Footer>
                                    </Card>

                                    {/* Notification Forms */}
                                    <Row>
                                        <Col lg={6} className="mb-4">
                                            <Card className="h-100 shadow-sm">
                                                <Card.Header className="bg-white">
                                                    <h5 className="mb-0">Appointment Booked Notification</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <p className="text-muted">Alert sent upon successful booking of an appointment</p>

                                                    <Form className="mt-4">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Notification Type</Form.Label>
                                                            <Form.Select>
                                                                <option>SMS</option>
                                                                <option>Email</option>
                                                                <option>SMS + Email</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Notification Content</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={4}
                                                                placeholder="Enter notification content here"
                                                                defaultValue="Hi {patient_name}, your appointment has been successfully booked for {appointment_date} at {appointment_time}. We look forward to seeing you!"
                                                            />
                                                        </Form.Group>

                                                        <div className="d-flex mt-4">
                                                            <Button variant="outline-primary" className="me-2">
                                                                Preview Notification
                                                            </Button>
                                                            <Button variant="primary">
                                                                Set Notification
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        <Col lg={6} className="mb-4">
                                            <Card className="h-100 shadow-sm">
                                                <Card.Header className="bg-white">
                                                    <h5 className="mb-0">New Custom Notification</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <p className="text-muted">Send custom notification reminders</p>

                                                    <Form className="mt-4">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Notification Target</Form.Label>
                                                            <Form.Select>
                                                                <option>Everyone</option>
                                                                <option>Confirmed</option>
                                                                <option>Not Confirmed</option>
                                                                <option>Cancelled</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Notification Type</Form.Label>
                                                            <Form.Select>
                                                                <option>SMS + Email</option>
                                                                <option>SMS</option>
                                                                <option>Email</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Set Date & Time</Form.Label>
                                                            <Form.Select>
                                                                <option>3 days before appointment</option>
                                                                <option>1 day before appointment</option>
                                                                <option>Same day reminder</option>
                                                                <option>2 hours before appointment</option>
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Use specific date & time"
                                                            />
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Notification Content</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={4}
                                                                placeholder="Enter notification content here"
                                                            />
                                                        </Form.Group>

                                                        <div className="d-flex mt-4">
                                                            <Button variant="outline-primary" className="me-2">
                                                                Preview Notification
                                                            </Button>
                                                            <Button variant="primary">
                                                                Send Notification
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default NotificationManagementPage;